import { emitAngularEvent, subscribeToAngularEvent } from 'services/utils/angularUtils';

export default {
    namespaced: true,
    state: {
        selectedAppKey: null,
        testGroup: 'A'
    },
    mutations: {
        setSelectedAppKey(state, appKey) {
            state.selectedAppKey = appKey;
        },
        setSelectedTestGroup(state, testGroup) {
            state.testGroup = testGroup;
        }
    },
    actions: {
        selectAppKey({ commit }, appKey) {
            commit('setSelectedAppKey', appKey);
            emitAngularEvent('selectedAppKeyChangedExternally', appKey);
        },
        selectTestGroup({ commit }, testGroup) {
            commit('setSelectedTestGroup', testGroup);
            emitAngularEvent('selectedTestGroupChangedExternally', testGroup);
        }
    },
    getters: {
        getSelectedAppKey: (state) => state.selectedAppKey,
        getTestGroup: (state) => state.testGroup
    }
};

/**
 * Initialize the app state event subscriptions
 * @param {import('vuex').Store} store
 */
export const appStateInit = (store) => {
    subscribeToAngularEvent('setSelectedAppKey', (e, appKey) => {
        store.commit('apps/setSelectedAppKey', appKey);
    });

    subscribeToAngularEvent('setSelectedTestGroup', (e, testGroup) => {
        store.commit('apps/setTestGroup', testGroup);
    });
};
